import React from "react";
import T from "i18n-react";
import Styles from "./styles.module.scss";
import Button from "../Button";
import { connect } from "react-redux";
import ShareWidget from "../ShareWidget/ShareWidget";
import { IConfirmOrderProps } from "./types.d";
import { SelectedOrderType } from "../../Payment/types.d";
import { ReactComponent as ThumbsUpSVG } from "../../../imges/ThumbsUp.svg";
import { _ChangeTable } from "../../../redux/actions/index";
import { useAuth0 } from "../../../yoello-lib/modules/auth/Auth0";
import IConsumerUser from "../../../yoello-lib/modules/auth/IConsumerUser";
function ConfirmOrder(props: IConfirmOrderProps) {
  const { user } = useAuth0()!;
  function setOrderText() {
    if (props.OrderType === SelectedOrderType.CLICK) {
      return "Payment.OrderCollectText";
    } else if (props.OrderType === SelectedOrderType.DELIVERY) {
      return "Payment.OrderDeliveryText";
    } else {
      return `Payment.OrderTableText`;
    }
  }

  function getOrderFeedback() {
    if (props.OrderType === SelectedOrderType.TABLE) {
      return (
        <span>
          {props.tableArea},<b>{props.Table}</b>
        </span>
      );
    } else if (props.OrderType === SelectedOrderType.CLICK) {
      return <span>{props.TimeSlot}</span>;
    } else if (props.OrderType === SelectedOrderType.DELIVERY) {
      return (
        <span>
          {props.TimeSlot}
          <br />
          {props.deliveryAddress?.address} {props.deliveryAddress?.city}{" "}
          {props.deliveryAddress?.postcode}
        </span>
      );
    } else {
      return null;
    }
  }

  function userName() {
    const userProfile = user as IConsumerUser;
    if (userProfile !== undefined) {
      return userProfile.first_name;
    }
    return "";
  }
  return (
    <div className={Styles.ConfirmPayment}>
      <div
        style={{
          position: "absolute",
          top: "15px",
          right: "15px",
        }}
      >
        <Button
          onClick={props.CloseDrawer}
          dataComponentName="ExitButton"
          iconClassName={"consumer-close"}
          style={{
            position: "unset",
            color: "#AAB6D3",
            fontSize: "1.5rem",
          }}
          isHeaderBtn
        />
      </div>

      <div className={Styles.lineBar} />
      <div className={Styles.ConfirmOrderContainer}>
        <div
          style={{
            padding: "0 0.9rem",
          }}
        >
          <T.p
            className={Styles.ThankYouText}
            text={{ key: `Payment.ThankYou`, name: userName() }}
          />
          <div
            style={{
              margin: "1rem 0",
            }}
          >
            <ThumbsUpSVG width="32px" height="32px" />
          </div>

          <p className={Styles.OrderCompletedText}>
            {T.translate("Payment.YourOrderHasBeen")}
            <br />
            <strong>{T.translate("Payment.SuccessfullyCompleted")}</strong>
          </p>
        </div>

        <div
          style={{
            marginTop: "0.625rem",
          }}
        >
          <div className={Styles.OrderInfoBox}>
            <div className={Styles.OrderIdDiv}>
              <T.p text={{ key: `Payment.OrderId` }} />
              <p>
                <strong data-component-name="orderId">{props.orderId}</strong>
              </p>
            </div>
            <div>
              <p className={Styles.OrderSentText}>
                {T.translate(setOrderText())}
              </p>
              <p className={Styles.OrderSentInfoText}>{getOrderFeedback()}</p>
            </div>
          </div>
          <div
            style={{
              marginTop: "1.25rem",
            }}
            className={Styles.ViewOrderHistoryDiv}
          >
            <p>{T.translate("Payment.ViewOrderHistory")}</p>
            <Button
              title="OrderHistory"
              iconClassName="consumer-right-arrow"
              onClick={() => props.openSettingsPage()}
              isYoelloBtn
            />
          </div>
          <div
            style={{
              padding: "1rem 0",
              borderTop: "1px solid #FFFFFF",
              borderBottom: "1px solid #FFFFFF",
            }}
          >
            <ShareWidget {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, {
  _ChangeTable,
})(ConfirmOrder);
